import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const appUrl = process.env.REACT_APP_EXTERNAL_APP_URL || 'https://aupairshare.base44.app';

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleAppRedirect = () => {
    window.open(appUrl, '_blank');
  };

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/families', label: 'For Families' },
    { to: '/au-pairs', label: 'For Au Pairs' },
    { to: '/safety', label: 'Safety' },
    { to: '/about', label: 'About' }
  ];

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-slate-200 shadow-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center lg:justify-between h-48 py-2">
          {/* Logo - Centered on mobile, left on desktop */}
          <Link to="/" className="flex items-center group absolute lg:relative left-1/2 lg:left-auto transform -translate-x-1/2 lg:transform-none">
            <img 
              src="https://customer-assets.emergentagent.com/job_flexible-families/artifacts/d41tdoag_my-project-page-1.png"
              alt="Au Pair Share"
              className="h-64 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-slate-600 hover:text-slate-900 font-medium transition-colors duration-200"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:block">
            <Button
              onClick={handleAppRedirect}
              className="bg-slate-700 hover:bg-slate-800 text-white px-6"
            >
              Open the App
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="lg:hidden p-2 text-slate-600 hover:text-slate-900 absolute right-4"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-slate-200">
          <nav className="container mx-auto px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="block text-slate-600 hover:text-slate-900 font-medium py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Button
              onClick={handleAppRedirect}
              className="w-full bg-slate-700 hover:bg-slate-800 text-white mt-4"
            >
              Open the App
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
